import * as ReactService from "@intech/react-service";

class Version extends ReactService.BaseService {
  constructor() {
    super("");
  }

  Buscar = () =>
    this.CreateRequest<string>(ReactService.RequestType.GET, ``);

}

export const VersionService = new Version();
